module.exports = __webpack_public_path__ + "resources/img/img_logo_pulsar_m_jp.e2740ea19ef95578312eed5d5a886c27.png";